import { Column, Row } from '../Grid/Grid';
import Text from '../Text/Text';
import { LeftSpaced, Spaced } from '../Spaced/Spaced';
import Radio from '../Form/Radio/Radio';
import Button from '../Button/Button';

function SingleOptionItem({
  title,
  subtitle,
  secondSubtitle,
  selected,
  onClick,
  left,
  ...props
}: SingleOptionItemInternalProps) {
  return (
    <li>
      <Button type="panel" onClick={onClick} data-testid={props['data-testid']}>
        <Spaced>
          <Row justifyContent="space-between">
            <Column>
              <Row justifyContent="space-between" alignItems="flex-start">
                <Radio selected={selected} />
                <LeftSpaced>
                  <Column>
                    <Text type="primary-bold">{title}</Text>
                    {subtitle && <Text type="subtitle">{subtitle}</Text>}
                    {secondSubtitle && <Text type="subtitle">{secondSubtitle}</Text>}
                  </Column>
                </LeftSpaced>
              </Row>
            </Column>
            {left}
          </Row>
        </Spaced>
      </Button>
    </li>
  );
}

export default SingleOptionItem;
